<template>
    <thbfx :type="type" :timeType="timeType" :treeAddress="'/analysis/tbfx'"></thbfx>
</template>
<script>
    import thbfx from "./page/thbfx"
    export default {
        data() {
            return {
                type:"0",
                timeType:[
                    { type: "day", label: "日" },
                    { type: "month", label: "月" }
                ]
            }
        },
        mounted() {
            console.log(123);
        },
        components:{
            thbfx
        }
    }
</script>